<div role="listitem" class="puntnotities-itemrow"  *ngFor="let notitie of notities trackBy:getNotitieId">

    <i  aria-hidden="true"  class="icon-notities-dots"></i>

    <div class="puntnotities-inhoud-col">
      <strong>{{notitie.PersoonNaam}}</strong> <span class="padleft">{{notitie.DatumUpdate | date}}</span>
      <pre class="wrap">{{notitie.Inhoud}}</pre>
    </div>

    <div class="puntnotities-buttons-col" >
      <a href="#" *ngIf="notitie.Persoonlijk" aria-label="Wijzig notitie" class="icon-pencil c2-clickable" (click)="navigateToWijzigNotitie(notitie)"></a>
      <a href="#" role="button" *ngIf="notitie.Persoonlijk" aria-label="Verwijder notitie" class="icon-close c2-clickable" (click)="verwijderNotitie(notitie)"></a>
      <span aria-hidden="true" class="puntnotities-aantal">{{notitie.AantalPersonen}}</span>
      <i role="img" [attr.aria-label]="'Aantal bestemmelingen: '+notitie.AantalPersonen" class="icon-user"></i>
      <a href="#" class="icon-reply c2-clickable" aria-label="Reageer op notitie" (click)="navigateToReageerNotitie(notitie)"></a> 
    </div>
    
  </div>

  <div class="puntnotities__moreresults" *ngIf="hasMoreResults">
    <button class="btn btn-default" (click)="onGetMoreResults()">Meer...</button> 
  </div>